import React, { useRef, useState } from 'react'
import { Modal, Form, Input, Row, Col, Select } from 'antd'
import { IPagination } from 'interfaces'
import { ISystem } from 'interfaces/system.interface'
import { useGetSystemsQuery } from 'services/reachware.service'
import { useHandleErrors } from 'hooks/handle-errors.hook'
import { SafeJSONParser } from 'utils'
const { Option } = Select

export interface IFlowsTable {
  key?: string | number
  name: string
  code: string
  source?: string
  sourceId: string | number
  destination?: string
  destinationId: string | number
  description: string
}

interface ICollectionCreateFormProps {
  visible: boolean
  onOk: (values: IFlowsTable) => void
  onCancel: () => void
  modalTitle: string
}

export const AddFlowModal = (props: ICollectionCreateFormProps) => {
  const { visible, onOk, onCancel, modalTitle } = props
  const formRef = useRef(null)
  const [form] = Form.useForm()
  const [selectedSystemName, setSelectedSystemName] = useState('')
  const {
    data: systems,
    isLoading: getSystemsLoading,
    error: getSystemsError,
  } = useGetSystemsQuery({
    limit: 5,
    filter: {
      name: { contains: selectedSystemName },
    },
  })
  useHandleErrors(getSystemsError)

  const handleSubmit = async () => {
    const values = await form.validateFields()
    onOk({ ...values, sourceSolutions: [values.source], destinationSolutions: [values.destination] })
    form.resetFields()
  }

  return (
    <Modal
      transitionName=''
      width={400}
      visible={visible}
      title={modalTitle}
      okText='Add'
      okButtonProps={{ className: 'w-32 rounded-[4px]' }}
      cancelButtonProps={{ className: 'w-32 rounded-[4px]' }}
      cancelText='Cancel'
      onCancel={onCancel}
      onOk={handleSubmit}
    >
      <Form form={form} name='flowForm' layout={'vertical'} ref={formRef}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className='w-100'>
          <Col span={24}>
            <Form.Item name='name' label='Name' rules={[{ required: true, message: 'name is missing' }]}>
              <Input className='h-10' placeholder='Name' />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label='Source System' name='source' rules={[{ required: true, message: 'source is missing' }]}>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder='Source System'
                optionFilterProp='children'
                loading={getSystemsLoading}
                onSearch={setSelectedSystemName}
                filterOption={(input, option) =>
                  option ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                }
              >
                {systems &&
                  systems.edges.map(({ node: system }) => {
                    return (
                      <Option key={system.id} value={system.id}>
                        {system.name}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='Destination System'
              name='destination'
              rules={[{ required: true, message: 'destination is missing' }]}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder='Destination System'
                optionFilterProp='children'
                loading={getSystemsLoading}
                onSearch={setSelectedSystemName}
                filterOption={(input, option) =>
                  option ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                }
              >
                {systems &&
                  systems.edges.map(({ node: system }) => {
                    return (
                      <Option key={system.id} value={system.id}>
                        {system.name}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='description'
              label='Description'
              rules={[{ required: true, message: 'description is missing' }]}
            >
              <Input.TextArea placeholder='Type...' style={{ height: '82px' }} autoSize={{ minRows: 2, maxRows: 4 }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
